import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useNuxtApp } from '#app'
import { useSyncData } from '@/composables/useSyncData'
import { useAuthStore } from '@/stores/useAuthStore'
import type { Pass } from '@/_api/models/pass'

export const usePassStore = defineStore('pass', () => {
  const { $api, $grants, $features } = useNuxtApp()
  const authStore = useAuthStore()

  const accountId = computed(() => authStore.activeGuid)

  const {
    items: passes,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    sync: _sync,
    findById,
  } = useSyncData<Pass>({
    service: $api.pass,
    key: 'passes',
    accountId,
    grants: { pass: ['view'] },
  })

  const sync = async (options?: { force?: boolean; change?: boolean }) => {
    if ($features && !$features.get('passes')) {
      return
    }

    if ($grants && !$grants.all({ pass: ['view'] })) {
      return
    }

    await _sync(options)
  }

  const syncDate = computed(() => syncState.value.date)

  const all = computed(() => passes.value)

  const allowedOnline = computed(() =>
    passes.value.filter(pass => pass.allowInternet)
  )

  return {
    passes,
    count,
    hydrated,
    syncState,
    isSyncing,
    syncProgress,
    syncDate,
    sync,
    findById,
    all,
    allowedOnline,
  }
})
